export default __webpack_public_path__ + "static/media/Treks.22fc0647.svg";